(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ct-carousel-autoplay"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ct-carousel-autoplay')) {
  customElements.define('ct-carousel-autoplay', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = document.getElementById(this.dataset.trackId);
      this.root = this.closest('ct-video-carousel, ct-proof-carousel');
      if (!this.track || !this.root) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.hovered = false;
      this.pointerActive = false;
      const sync = () => this.sync();
      this.root.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') { this.hovered = true; this.sync(); }
      }, options);
      this.root.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); }, options);
      this.root.addEventListener('focusin', sync, options);
      this.root.addEventListener('focusout', () => queueMicrotask(() => {
        if (this.isConnected) this.sync();
      }), options);
      this.track.addEventListener('pointerdown', () => { this.pointerActive = true; this.sync(); }, options);
      ['pointerup', 'pointercancel'].forEach(name => document.addEventListener(name, () => {
        if (this.pointerActive) { this.pointerActive = false; this.sync(); }
      }, options));
      this.track.addEventListener('scroll', sync, {...options, passive:true});
      this.root.querySelectorAll('video').forEach(video => {
        ['play', 'pause', 'ended'].forEach(name => video.addEventListener(name, sync, options));
      });
      document.addEventListener('visibilitychange', sync, options);
      this.reduced.addEventListener('change', sync, options);
      this.visibilityObserver = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .25;
        this.sync();
      }, {threshold:[0,.25]});
      this.visibilityObserver.observe(this.track);
      this.resizeObserver = new ResizeObserver(sync);
      this.resizeObserver.observe(this.track);
      this.sync();
    }
    canMove() {
      return this.track.children.length > 1 && this.track.scrollWidth > this.track.clientWidth + 3;
    }
    blocked() {
      return this.reduced.matches || !this.visible || document.hidden || this.hovered || this.pointerActive || this.root.contains(document.activeElement) || [...this.root.querySelectorAll('video')].some(video => !video.paused && !video.ended);
    }
    sync() {
      clearTimeout(this.timer);
      const movable = this.canMove();
      if (movable && !this.blocked()) this.timer = setTimeout(() => this.advance(), 5000);
    }
    advance() {
      if (!this.canMove() || this.blocked()) return;
      const direction = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
      const current = Math.abs(this.track.scrollLeft);
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      const card = this.track.children[0];
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const next = current >= maximum - 3 ? 0 : Math.min(maximum, current + card.getBoundingClientRect().width + gap);
      this.track.scrollTo({left:next * direction, behavior:'smooth'});
      this.sync();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.visibilityObserver?.disconnect();
      this.resizeObserver?.disconnect();
      this.controller = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ct-claim-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ct-claim-offer')) {
  customElements.define('ct-claim-offer', class extends HTMLElement {
    static lastClick = 0;

    connectedCallback() {
      this.button = this.querySelector('button');
      this.message = this.querySelector('[role="status"]');
      this.root = document.querySelector('#MainContent [id^="MainProduct-"]');
      if (!this.root) return;
      this.onClick = () => {
        const native = this.getNative();
        if (!native || this.isBusy(native) || native.disabled) return;
        if (Date.now() - this.constructor.lastClick < 1000) return;
        this.constructor.lastClick = Date.now();
        this.message.hidden = true;
        this.button.focus({ preventScroll: true });
        const previous = native.dataset.ctCheckout;
        native.dataset.ctCheckout = 'true';
        try { native.click(); }
        finally {
          if (previous === undefined) delete native.dataset.ctCheckout;
          else native.dataset.ctCheckout = previous;
        }
        this.sync();
      };
      this.button.addEventListener('click', this.onClick);
      customElements.whenDefined('product-form').then(() => {
        if (!this.isConnected) return;
        this.observer = new MutationObserver(() => this.sync());
        this.observer.observe(this.root, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['disabled','aria-disabled','class','hidden']});
        this.sync();
      });
    }

    getNative() {
      return this.root.querySelector('product-form form button[type="submit"][name="add"]');
    }

    isBusy(native) {
      return native.classList.contains('loading') || native.getAttribute('aria-disabled') === 'true';
    }

    sync() {
      const native = this.getNative();
      if (!native) {this.button.disabled = true;return;}
      const busy = this.isBusy(native);
      this.button.disabled = native.disabled || busy;
      this.button.setAttribute('aria-busy', String(busy));
      const error = native.closest('product-form').querySelector('.product-form__error-message-wrapper');
      const text = error && !error.hidden ? error.querySelector('.product-form__error-message')?.textContent.trim() : '';
      this.message.textContent = text || '';
      this.message.hidden = !text;
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.onClick);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ct-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ct-delivery-estimate')) {
  customElements.define('ct-delivery-estimate', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const countries = JSON.parse(this.querySelector('[data-shipping-countries]').textContent);
      const root = this.dataset.root.endsWith('/') ? this.dataset.root : this.dataset.root + '/';
      fetch(root + 'browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin' })
        .then(response => { if (!response.ok) throw new Error('Country unavailable'); return response.json(); })
        .then(data => {
          const code = data.detected_values?.country?.handle;
          const country = countries[code];
          if (!country || !this.isConnected) return;
          this.querySelector('[data-shipping-label]').textContent = this.dataset.shippingFormat.replace('[country]', country.name);
          const flag = this.querySelector('[data-country-flag]');
          flag.src = country.flag;
          flag.alt = country.name;
          flag.hidden = false;
          this.querySelector('[data-country-code]').textContent = code;
          this.querySelector('[data-country-destination]').hidden = false;
        })
        .catch(() => {});
    }

  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ct-home-design"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.ctHomepageReady) return;
  window.ctHomepageReady = true;
  document.addEventListener('click', event => {
    const button = event.target.closest('button');
    if (!button) return;
    if (button.matches('.pz-menu-toggle')) {
      const nav = document.getElementById(button.getAttribute('aria-controls'));
      if (nav) { nav.hidden = !nav.hidden; button.setAttribute('aria-expanded', String(!nav.hidden)); }
    }
    const galleries = {'previous-video':['media-gallery',-1], 'next-video':['media-gallery',1], 'previous-review':['experience-gallery',-1], 'next-review':['experience-gallery',1]};
    if (galleries[button.id]) {
      const [id, direction] = galleries[button.id];
      const gallery = document.getElementById(id);
      const card = gallery && gallery.firstElementChild;
      if (card) gallery.scrollBy({left:direction*(card.getBoundingClientRect().width+20),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    }
    if (button.matches('[data-ct-dialog]')) {
      const dialog = document.getElementById(button.dataset.ctDialog);
      if (dialog) { dialog.showModal(); const v = dialog.querySelector('video'); if(v) v.play().catch(()=>{}); }
    }
    if (button.matches('.pz-dialog-close')) button.closest('dialog')?.close();
  });
  document.addEventListener('click',event=>{
    const link = event.target.closest('#mobile-nav a');
    if(link){link.closest('nav').hidden=true;document.querySelector('.pz-menu-toggle')?.setAttribute('aria-expanded','false');}
    if(event.target.matches('dialog[open]')){
      const rect=event.target.getBoundingClientRect();
      if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)event.target.close();
    }
  });
  document.addEventListener('close',event=>{if(event.target.matches('dialog'))event.target.querySelectorAll('video').forEach(v=>v.pause());},true);
  document.addEventListener('keydown', event => {
    if(!event.target.matches('#media-gallery,#experience-gallery') || !['ArrowLeft','ArrowRight'].includes(event.key))return;
    event.preventDefault();event.target.scrollBy({left:(event.key==='ArrowLeft'?-1:1)*event.target.clientWidth*.8,behavior:'smooth'});
  });
})();
  } catch(e) { console.error(e); }
})();

})();
